import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, Button, Row, Col, message, Modal, Select, DatePicker, notification } from "antd";
import moment from "moment";
import { updateBookingRental } from "../../../api/booking.service";
import { getVehiclesTypes } from "../../../api/vehicles-type.service";

const { Option } = Select;
const { RangePicker } = DatePicker;

const EditRentalBookingPackageModal = ({
    vehicleData,
    onClose,
    fetchVehicles,
    isModalOpen,
    setIsModalOpen,
    handleOk,
    handleCancel,
    isViewOnly = false,
}) => {
    const [form] = Form.useForm();
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    // Fetch vehicle types (i.e. available vehicles)
    const fetchPackages = async () => {
        try {
            setLoading(true);
            const data = await getVehiclesTypes();
            setVehicleTypes(data?.data || []);
        } catch (err) {
            notification.error({ message: "Failed to fetch vehicles" });
            setError("Failed to fetch vehicles");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPackages();
    }, []);

    useEffect(() => {
        if (vehicleData) {
            form.setFieldsValue({
                name: vehicleData.name,
                email: vehicleData.email,
                phone: vehicleData.phone,
                amount: vehicleData.amount,
                // Convert dateRange stored in vehicleData into moment objects.
                dateRange: vehicleData.dateRange
                    ? [moment(vehicleData.dateRange[0]), moment(vehicleData.dateRange[1])]
                    : [],
                // Pre-select the vehicle by setting the selectedVehicle to the vehicle's id.
                selectedVehicle: vehicleData.selectedVehicle?.id,
                status: vehicleData.status,
            });
        }
    }, [vehicleData, form]);

    const onFinish = async (values) => {
        try {
            // Format the dateRange to an object with start and end ISO strings
            const payload = {
                ...values,
                dateRange: [
                    values.dateRange[0].toISOString(),
                    values.dateRange[1].toISOString(),
                ],
            };
            // Call your updateBookingTour API passing the referenceNo and payload.
            await updateBookingRental(vehicleData.referenceNo, payload);
            message.success("Booking updated successfully!");
            fetchVehicles();
            setIsModalOpen(false);
        } catch (error) {
            message.error(error.message);
            console.error("Error:", error);
        }
    };

    return (
        <Modal
            className="vt-modal"
            footer={null}
            destroyOnClose
            title={`${isViewOnly ? "View" : "Edit"} Rental Booking`}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            onClose={handleCancel}
        >
            <Form disabled={isViewOnly} layout="vertical" form={form} onFinish={onFinish}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Name"
                            name="name"
                            rules={[{ required: true, message: "Please enter the customer's name" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                { required: true, message: "Please enter the customer's email" },
                                { type: "email", message: "Please enter a valid email" },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Phone"
                            name="phone"
                            rules={[{ required: true, message: "Please enter the customer's phone" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Selected Vehicle"
                            name="selectedVehicle"
                            rules={[{ required: true, message: "Please select a vehicle" }]}
                        >
                            <Select
                                placeholder="Select a vehicle"
                                options={
                                    vehicleTypes?.map((vehicle) => ({
                                        label: vehicle.name,
                                        value: vehicle.id,
                                    })) || []
                                }
                            />
                        </Form.Item>
                    </Col>
                </Row>



                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Date Range"
                            name="dateRange"
                            rules={[{ required: true, message: "Please select a date range" }]}
                        >
                            <RangePicker style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Status"
                            name="status"
                            rules={[{ required: true, message: "Please select a status" }]}
                        >
                            <Select>
                                <Option value="CONFIRMED">Confirmed</Option>
                                <Option value="PENDING">Pending</Option>
                                <Option value="CANCELLED">Cancelled</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                {isViewOnly && <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Amount (PKR)"
                            name="amount"
                            rules={[{ required: true, message: "Please enter the amount" }]}
                        >
                            <InputNumber min={0} style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                </Row>}


                {!isViewOnly && (
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Update
                        </Button>
                        <Button style={{ marginLeft: 8 }} onClick={() => setIsModalOpen(false)}>
                            Cancel
                        </Button>
                    </Form.Item>
                )}
            </Form>
        </Modal>
    );
};

export default EditRentalBookingPackageModal;
